module.exports = __webpack_public_path__ + "img/02.99e428e3.jpg";